import { FC } from "react";
import { useTranslation } from "react-i18next";
import DocumentsIconSVG from "../../resources/svg/DocumentsIconSVG";
import AccomplishedIconSVG from "../../resources/svg/AccomplishedIconSVG";
import CustomToast from "../../../custom-components/CustomToast";
import useToastMessage from "../../../custom-hooks/useToastMessage";
import { ResponseMessages } from "../../../domain/enums/common/ResponseMessagesEnum";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";
import { useSelector } from "react-redux";
import { selectUserReferralLink } from "../../../slices/user-slice";

const ReferralLinkSection: FC = () => {
    const { message, setMessage, resetMessage } = useToastMessage();
    const { upTo650, moreOrEqual650 } = useScreenSize();
    const { t } = useTranslation();
    const referralLink = useSelector(selectUserReferralLink);
    const copyReferralLinkHandler = async () => {
        await navigator.clipboard.writeText(referralLink);
        setMessage("common.copied", ResponseMessages.SUCCESS);
    };

    return (
        <div className="flex flex-col items-center">
            <span className="H24B H20B text-textWhite">{t("subscription.referralTitle1")}</span>
            <span className="H24B H20B text-textWhite mb-10 dmax2:mb-6">{t("subscription.referralTitle2")}</span>
            {moreOrEqual650 && (
                <div className="relative flex items-center justify-between w-[606px] ti9:w-full h-[75px] ti9:h-[65px] bg-[rgba(255,255,255,0.05)] rounded-[9px] px-7 mb-6">
                    <span className="H20 text-textWhite w-[351px] truncate">{referralLink}</span>
                    <div
                        onClick={copyReferralLinkHandler}
                        className="button H20 text-textWhite rounded-[12px] h-[47px] px-[19px] transition duration-300"
                    >
                        {t("common.copy")}
                        <DocumentsIconSVG className="ml-2 text-textWhite" />
                    </div>
                    <CustomToast
                        messageObj={message}
                        resetMessageObj={resetMessage}
                        wrapClassName="w-full"
                        staticClassName="w-full"
                        staticType
                        singleMessageMode
                        tooltipElement={
                            <div className="absolute top-8 right-[60px] H10 text-textWhite bg-backgroundInput rounded-[30px] h-[25px] flex items-center px-3">
                                {t("common.linkCopied")}
                                <AccomplishedIconSVG className="w-4 h-4 text-textWhite ml-1.5" />
                            </div>
                        }
                    />
                </div>
            )}
            {upTo650 && (
                <div className="flex flex-col w-full mb-6">
                    <div className="flex items-center bg-backgroundInput rounded-[8px] w-full h-[45px] px-9">
                        <span className="H16 text-textWhite w-full truncate">{referralLink}</span>
                    </div>
                    <div
                        onClick={copyReferralLinkHandler}
                        className="button H16 text-textWhite rounded-[12px] h-[42px] w-full mt-2 transition duration-300"
                    >
                        {t("common.copy")}
                        <DocumentsIconSVG className="ml-2 text-textWhite" />
                    </div>
                    <CustomToast
                        messageObj={message}
                        resetMessageObj={resetMessage}
                        wrapClassName="w-full"
                        staticClassName="w-full"
                        staticType
                        singleMessageMode
                        tooltipElement={
                            <div className="absolute top-[100px] left-0 right-0 mx-auto H10 text-textWhite bg-backgroundInput rounded-[30px] w-fit h-[25px] flex items-center px-3">
                                {t("common.linkCopied")}
                                <AccomplishedIconSVG className="w-4 h-4 text-textWhite ml-1.5" />
                            </div>
                        }
                    />
                </div>
            )}
            <div className="flex flex-col max-w-[762px]">
                <span className="H16 dmax2:H14 text-textFaded text-center mb-2">
                    {t("subscription.referralCondition1")}
                </span>
                <span className="H16 dmax2:H14 text-textFaded text-center mb-2">
                    {t("subscription.referralCondition2")}
                </span>
                <span className="H16 dmax2:H14 text-textFaded text-center">{t("subscription.referralCondition3")}</span>
            </div>
        </div>
    );
};

export default ReferralLinkSection;
